module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/churches-475c78cb27d7376ca9f7fe25e282aa10.webp";